import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import AsyncTableContainer from '../../Table/AsyncTableContainer';

import CheckmarkOrXComponent from '../../Table/CheckmarkOrXComponent';

import { formatDate } from '../../../utils';
import { getFullName } from '../../Person/utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../../Table/constants';

import { secondaryColor } from '../../../theme';
import ListActions from '../../Table/ListActions';
import Switch from '../../Table/Switch';
import { limitFilter } from '../../Table/filters';

const BrivoClearUsersComponent = (props) => {
  const { t } = useTransl();

  const {
    listParams,
    onLoad,
    getItems,
    items,
    selectedUsers,
    listKey,
    onSelectUser,
    onClearBrivoUsers,
    isLoading,
  } = props;

  const columns = [
    {
      Header: ' ',
      accessor: ({ isSelected }) => (
        <Box display="flex" justifyContent="center">
          <Switch value={isSelected} isDisabled={isLoading} />
        </Box>
      ),
      id: 'isSelected',
      sortable: false,
      width: 50,
    },
    {
      Header: t('title.name'),
      accessor: (entry) => getFullName(entry),
      id: 'name',
      sortable: false,
    },
    {
      Header: t('title.createdAt'),
      accessor: ({ created }) => formatDate(created),
      id: 'created',
      sortable: false,
    },
    {
      Header: t('title.updatedAt'),
      accessor: ({ updated }) => formatDate(updated),
      id: 'updated',
      sortable: false,
    },
    {
      Header: t('title.suspended'),
      accessor: ({ suspended }) => <CheckmarkOrXComponent value={suspended} />, // checkmark
      id: 'suspended',
      sortable: false,
    },
    {
      Header: t('title.id'),
      accessor: ({ id }) => id,
      id: 'id',
      sortable: false,
    },
    {
      Header: t('title.externalId'),
      accessor: ({ externalId }) => externalId,
      id: 'externalId',
      sortable: false,
    },
    {
      Header: t('title.person'),
      accessor: ({ person }) => person,
      id: 'person',
      sortable: false,
    },
  ];

  const filters = [limitFilter(listParams)];

  const defaultParams = {};

  const onRowClick = (rowInfo) => {
    if (isLoading) return null;
    const user = rowInfo?.original;
    return onSelectUser(user);
  };

  const rowStyles = {
    style: {
      cursor: isLoading ? 'default' : 'pointer',
    },
  };

  const actionTitle = selectedUsers.length
    ? t('externalAccounts.removeSelected', {
        usersCount: selectedUsers.length,
      })
    : t('externalAccounts.selectToRemove');

  const action = {
    label: actionTitle,
    color: secondaryColor,
    onClick: () => onClearBrivoUsers(),
    disabled: !selectedUsers.length,
  };

  return (
    <>
      <Box width="100%" display="flex" justifyContent="flex-end">
        <ListActions actions={[action]} />
      </Box>
      <AsyncTableContainer
        tableId={TABLE_ID.brivoCleanupTable}
        title={t('externalAccounts.cleanBrivoUsers')}
        columns={columns}
        defaultSort={TABLE_CONSTANTS.name}
        defaultSortDesc={false}
        manual
        isHideSearch
        filters={filters}
        showFiltersAreApplied={false}
        onLoad={onLoad}
        items={items}
        getItems={getItems}
        listParams={listParams}
        defaultParams={defaultParams}
        listKey={listKey}
        onRowClick={onRowClick}
        rowStyles={rowStyles}
        action={null}
      />
    </>
  );
};

BrivoClearUsersComponent.propTypes = {
  listParams: PropTypes.instanceOf(Object).isRequired,
  onLoad: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  onSelectUser: PropTypes.func.isRequired,
  items: PropTypes.instanceOf(Object).isRequired,
  listKey: PropTypes.string.isRequired,
  onClearBrivoUsers: PropTypes.func.isRequired,
  selectedUsers: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default BrivoClearUsersComponent;
